import React, { Component } from "react";
import styled from "styled-components";
import Splash from "../../shared/Splash";
import Footer from "../../shared/Footer";
import Steps from "./components/Steps";
import Banner from "../../shared/Banner";
import Professions from "./components/Professions";
// import Form from "../../shared/Form";
import BannerSplash from "../../../assets/banner.jpg";
import BannerSplash2 from "../../../assets/banner2.jpg";
import Helmet from "react-helmet";
import { withRouter } from "react-router-dom";
import Testimonials from "../../shared/Testimonials";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

class Home extends Component {
  render() {
    return (
      <Wrapper>
        <Helmet
          title="AchieveCE | Approved Continuing Education"
          meta={[
            { name: "description", content: "Home Page for AchieveCE" },
            { property: "og:type", content: "website" },
            {
              property: "og:title",
              content: "Approved Continuing Education"
            },
            { property: "og:url", content: "http://achievece.com" }
          ]}
        />
        <Splash
          navigate={this.props.history}
          text={["APPROVED CONTINUING EDUCATION", "Your path to renewal"]}
          img={BannerSplash}
          id="home"
        />
        <Steps navigate={this.props.history} />
        <Banner navigate={this.props.history} img={BannerSplash2} id="home1" />
        <Professions />
        <Testimonials />

        {/* <Form
            type="home"
            title="Careers"
            text="We're always growing at AchieveCE! If you're interested in learning more about joining the team, tell us a bit about yourself."
          /> */}
        <Footer navigate={this.props.history} />
      </Wrapper>
    );
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/screens/Home/Home.jsx